// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { HorizontalBar, defaults, Bar } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";
import { mediaQueries } from "../../shared/config";

const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: true
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          display: true,
          labelString: "Race/Ethnicity"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          //set the labels to stack when they're too long
          //so they don't overflow out of the card
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label;
              } else {
                return label.split(" ");
              }
            } else {
              return label;
            }
          }
        },
        stacked: false,
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Percent of Students who Identify"
        }
      }
    ]
  },
  title: {
    display: false,
    text: "UCLA vs. Daily Bruin Race/Ethnicity Breakdown"
  },
  tooltips:{
    callbacks:{
      label: function(tooltipItem){
        return this._data.datasets[tooltipItem.datasetIndex].label +': ' + tooltipItem.yLabel + '%';
      }
    }
  }
};

interface EthnicitySectionBreakdownProps{
  caption: string;
}

class EthnicitySectionBreakdownBarChartCard extends React.Component <EthnicitySectionBreakdownProps>{
  constructor(props:EthnicitySectionBreakdownProps){
    super(props);
  }
  state = {
    labels: ["Black or African American",
          "White",
          "Hispanic or Latino",
          "Native American or American Indian",
          "Asian/Pacific Islander",
          "Multiracial",
          "Prefer not to say",
          "Middle Eastern"],
          datasets: [
            {
              data: [
                2.9,
                28.8,
                10.8,
                0.7,
                42.4,
                7.2,
                0.7,
                6.5
              ],
              backgroundColor: "#0080C6",
              label: "Fall 2021 Interns"
            },
            {
              data: [
                2.3,
                37.5,
                6.8,
                0,
                39.8,
                6.8,
                1.1,
                5.7
              ],
              backgroundColor: "#c377e0",
              label: "Contributors",
            },
            {
              data: [
                1.1,
                26.1,
                4.3,
                0,
                56.5,
                8.7,
                1.1,
                2.2
              ],
              backgroundColor: "#733B90",
              label: "Paid Staff",
            },
          ]
        };

  render() {
    const { mobile } = mediaQueries;
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            ${mobile} {
              font-size: 18px;
            }
          `}
        >
          Daily Bruin 2021-2022 Staff Level Race/Ethnicity Breakdowns
        </div>
        <div
          className={css`
            height: 500px;
            ${mobile} {
              height: 600px;
            }
            width: 100%;
          `}
        >
          <Bar
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: center;
          `}>
          {caption}
          </div>
      </Card>
    );
  }
}

export default EthnicitySectionBreakdownBarChartCard;
